import { Component, OnInit } from '@angular/core';
import { AuthenticationService, MessageQueService } from '../../services/index';
import { Params } from '../../models/index';
import CompareTwoInputsValidator from '../../validators/compareTwoInputsValidator';
import PasswordRulesValidator from '../../validators/passwordRulesValidator';
import { PasswordValidation } from '../../validators/passwordValidation';
import { Codes } from '../../models/index';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-changepassword',
  templateUrl: 'changePassword.component.html',
  styleUrls: ['changePassword.component.scss'],
  providers: [MessageQueService]
})

export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  showChange: boolean;

  constructor(private formBuilder: FormBuilder, private msgSvc: MessageQueService,  private authenticationService: AuthenticationService) {
    this.showChange = false;
  }

  ngOnInit() {
    this.msgSvc.setControlKey();
    this.changePasswordForm = this.formBuilder.group({
      change: this.formBuilder.group({
        userName: ['', Validators.compose([
          Validators.required,
          Validators.maxLength(30),
          Validators.minLength(4)])
        ],
        currentPassword: ['', Validators.compose([
          Validators.required,
          Validators.maxLength(60),
          PasswordRulesValidator()])
        ],
        newPassword: ['', Validators.compose([
          Validators.required,
          Validators.maxLength(60),
          PasswordRulesValidator(),
          CompareTwoInputsValidator('currentPassword', false)])
        ],
        confirmPassword: ['', Validators.compose([
          Validators.required,
          Validators.maxLength(60)])
        ],
      }, {validator: PasswordValidation.MatchPassword})
    });
  }
  home() {
    this.showChange = false;
    this.changePasswordForm.reset();
  }
  // this is called from login
  passwordChange(isVisible: boolean) {
    this.showChange = isVisible;
  }
  showChangePassword(): boolean {
    if (this.showChange) {
      return true;
    } else {
      return false;
    }
  }

  onSubmit() {
    const form = this.changePasswordForm.value;
    const changes: Params = Object.assign({}, form.change, { confirmPassword: undefined });
    this.authenticationService.changePassword(changes.userName, changes.currentPassword, changes.newPassword)
      .subscribe((codes: Codes[]) => {
        const code = codes.find((rc: Codes) => rc === Codes.ok);
        if (code === Codes.ok) {
          this.home();
        } else {
          for (const errorCode of codes) {
            switch (errorCode) {
              case Codes.requireUsername:
                this.setValidationErrorByControlName('change.userName', 'required');
                break;
              case Codes.requirePassword:
                this.setValidationErrorByControlName('change.currentPassword', 'required');
                break;
              case Codes.requiredNewPassword:
                this.setValidationErrorByControlName('change.newPassword', 'required');
                break;
              case Codes.invalidPassword:
                this.setValidationErrorByControlName('change.currentPassword', 'invalid');
                break;
              case Codes.userNamePasswordNotExist:
                this.setValidationErrorByControlName('change.userName', 'notexists');
                this.setValidationErrorByControlName('change.currentPassword', 'notexists');
                break;
              case Codes.passwordAlreadyExist:
                this.setValidationErrorByControlName('change.newPassword', 'exists');
                break;
              case Codes.accountLocked:
                this.setValidationErrorByControlName('change.userName', 'locked');
                break;
              case Codes.passwordMatch:
                this.setValidationErrorByControlName('change.newPassword', 'compareTwoInputs');
                break;

              default:
                break;
            }
          }
        }
      });
  }
  setBlurById(id: string) {
    const classListPasswordSidebar = document.getElementById(id).classList;
    classListPasswordSidebar.remove('show-sidebar');
    classListPasswordSidebar.add('hide-sidebar');
  }
  setFocusById(id: string) {
    const classListPasswordSidebar = document.getElementById(id).classList;
    classListPasswordSidebar.remove('hide-sidebar');
    classListPasswordSidebar.add('show-sidebar');
  }
  passwordKeyup(event: any, order: number) {
    const password: string = event.target.value;
    this.checkLength(password, order);

    if (order === 0) {
    this.checkRegEx(password, /[!@#$%^&*(){}[\]?~<>]/, 'password-symbol-rule');
    this.checkRegEx(password, /[A-Z]/, 'password-upper-case-letter');
    this.checkRegEx(password, /[a-z]/, 'password-lower-case-letter');
    this.checkRegEx(password, /\d/, 'password-number-rule');
    } else {
      this.checkRegEx(password, /[!@#$%^&*(){}[\]?~<>]/, 'newPassword-symbol-rule');
      this.checkRegEx(password, /[A-Z]/, 'newPassword-upper-case-letter');
      this.checkRegEx(password, /[a-z]/, 'newPassword-lower-case-letter');
      this.checkRegEx(password, /\d/, 'newPassword-number-rule');
    }
  }
  private checkRegEx(s: string, pattern: RegExp, id: string) {
    if (s.match !== null) {
      const isMatch = s.match(pattern);
      if (!isMatch) {
        this.showRuleNotMet(id);
      } else {
        this.showRuleMet(id);
      }
    }
  }
  private setValidationErrorByControlName(controlName: string, validatorType: string) {
    const control = this.changePasswordForm.get(controlName);
    const validator = {};
    validator[validatorType] = true;
    control.setErrors(validator);
    control.markAsTouched();
  }
  private checkLength(password: string, order: number) {
    let id = '';
    if (order === 0) {
      id = 'password-length-rule';
    } else {
      id = 'newPassword-length-rule';
    }

    if (password.length < 8) {
      this.showRuleNotMet(id);
    } else {
      this.showRuleMet(id);
    }
  }

  private showRuleMet(id: string) {
    const passwordLength = document.getElementById(id).classList;
    passwordLength.remove('rule-not-met');
    passwordLength.add('rule-met');
  }

  private showRuleNotMet(id: string) {
    const passwordLength = document.getElementById(id).classList;
    passwordLength.remove('rule-met');
    passwordLength.add('rule-not-met');
  }

  get userName() { return this.changePasswordForm.get('change.userName'); }
  get currentPassword() { return this.changePasswordForm.get('change.currentPassword'); }
  get newPassword() { return this.changePasswordForm.get('change.newPassword'); }
  get confirmPassword() { return this.changePasswordForm.get('change.confirmPassword'); }
}



// WEBPACK FOOTER //
// ./src/app/changePassword/changePassword.component.ts